import React from 'react';
import { FlagIcon, MapIcon } from '@iconicicons/react';
import { BadgeDisplay } from './BadgeDisplay';
import { Point } from '@/types';
import { Theme } from './hooks';
import { useFocusPoint } from '../hooks/useFocusPoint';
import { useDispatch } from 'react-redux';
import { setContextMenu } from '../points/pointsSlice';
import { isValidNumber } from '../utils/numberUtils';

export type PointBadgeProps = {
  point: Point;
  /**
   * @deprecated this prop is no longer needed.
   */
  theme?: Theme;
  extra_text?: React.ReactNode | React.ReactNode[];
  style?: React.CSSProperties;
  className?: string;
  showTspName?: boolean;
};

export const PointBadge: React.FC<PointBadgeProps> = ({
  point,
  extra_text = '',
  style = {},
  className,
  showTspName = false,
}) => {
  const dispatch = useDispatch();
  const focusPoint = useFocusPoint();

  const openPointMenu = (evt: React.MouseEvent) => {
    if (!isValidNumber(point?.id)) return;
    evt.preventDefault();
    dispatch(
      setContextMenu({
        pointId: Number(point.id),
        position: { x: evt.clientX, y: evt.clientY },
      }),
    );
  };

  if (!point) {
    return null;
  }

  return (
    <BadgeDisplay
      style={style}
      onClick={() => focusPoint(point.id)}
      role={Boolean(point.node) === true ? 'button' : undefined}
      className={className}
      onContextMenu={openPointMenu}
    >
      {showTspName && (
        <>
          {point.tsp_name}
          <br />
        </>
      )}
      {Boolean(point.node) === false && <MapIcon color="yellow" />}{' '}
      {point.delivery_zone_name?.trim() || 'N/A'}: {point.name}
      <br />
      {extra_text}
    </BadgeDisplay>
  );
};

export type MissingPointBadgeProps = {
  name: string;
  /** @deprecated this prop is no longer needed. */
  theme?: Theme;
  extra_text?: React.ReactNode | React.ReactNode[];
};

export const MissingPointBadge: React.FC<MissingPointBadgeProps> = ({
  name,
  extra_text = '',
}) => {
  return (
    <BadgeDisplay>
      <FlagIcon color="red" />
      {name}
      <br />
      {extra_text}
    </BadgeDisplay>
  );
};
